export default {
  APP_VERSION: '1.2026.08.20.13044',
  DEVTOOL_SOURCEMAPS: 'source-map', // eval-source-map
  CLIENT_SECRET: 'nN4gozTE7Um99ttqBDE75A==',
  CLIENT_ID: 'e7b174d6-59e7-4c39-9e26-6c515cc4edc7', //'e7b174d6-59e7-4c39-9e26-6c515cc4edc7', //'22d66314-d9d6-41b5-aa41-69ccf404ba3b'
  AZURE_AD_CLIENT_ID: 'b1585aa0-90dc-433a-8536-3033da6d4b21',
  GOOGLE_CLIENT_ID: '65696688316-5vh7ls5ifjo2jrglfl9jpvf8selmjjct.apps.googleusercontent.com',
  CAPTCHA_SITE_KEY: '6LdGIsAqAAAAAFAc2_-kzMw_NY4LMkDYGgX5mwSy',
  API_URL: 'https://apis-qa.automy.global', // 'https://apis-qa.automy.global',
  ASSETS_URL: 'https://assets.automy.global',
  SELECT_LIMIT: 50,
  SOCKET_CONNECTION_HUB: 'https://ws.automy.global',
  AZURE_SAS_TOKEN_URI: 'storageMediaManager/generate-sas-token',
  AZURE_BLOB_STORAGE_URL: 'https://automy.blob.core.windows.net',
  // Entity Token Doc URLs
  EN_TOKEN_URL:
    'https://automy.global/en/knowledge_center/estudio-admin/creacion-y-uso-de-tokens-externos-en-entidades',
  ES_TOKEN_URL:
    'https://automy.global/es/knowledge_center/estudio-admin/creacion-y-uso-de-tokens-externos-en-entidades',
  // Embed documents services
  OFFICE_APPS_LIVE_URL: 'https://view.officeapps.live.com/op/embed.aspx?src=',
  GOOGLE_DOCS_LIVE_URL: 'https://docs.google.com/viewer?url=',
  PDF_JS_WORKER_URL: 'https://unpkg.com/pdfjs-dist@2.2.228/build/pdf.worker.min.js',
  CORS_EVERYWHERE_SERVICE_URL: 'https://cors-anywhere.herokuapp.com/',
  DEFAULT_DATE_RANGE: 5,
  DEFAULT_LOCALE: 'es-PE',
  NUMERIC_DEFAULT_FORMAT: '#,###.00',
  DATE_RANGE_START_FORMAT: 'YYYY-MM-DDT00:00:00Z',
  DATE_RANGE_END_FORMAT: 'YYYY-MM-DDTHH:mm:ssZ',
  //  Google Maps
  GOOGLE_MAPS_API_URL: 'https://maps.googleapis.com/maps/api',
  GOOGLE_MAPS_API_KEY: 'AIzaSyBr8qn6M195ikm2DxjgAE6YBQ0k9FMucIs',
  GOOGLE_MAPS_GEOCODE_API_KEY: 'AIzaSyA67AeikKxUDAJNwDSmKNq7mXbwDFSWce8',
  GOOGLE_MAPS_DEFAULT_CENTER: {
    lat: -12.036676806688819,
    lng: -77.04271909623526,
  },
  GOOGLE_GEOLOCATION_ACCURACY: 50,
  GOOGLE_MAPS_MIN_ZOOM: 3,
  GOOGLE_MAPS_MAX_ZOOM: 18,
  GOOGLE_MAPS_DEFAULT_ZOOM: 18,
  GOOGLE_MAPS_LIBRARIES: ['places', 'geometry', 'marker'],
  USER_ADMIN_ROLES: ['admin', 'super-admin'],
  // Admin + global collaborator role — same module Launchpad affordances as
  // admin, except the `/configuration` sidebar (route authority).
  USER_STAFF_ROLES: ['admin', 'super-admin', 'collaborator'],
  // OData enum namespace for $filter expressions
  ODATA_ENUM_NAMESPACE: 'Automy.Core.Enums',
  // App Documentation
  DOC_SITE_URL: 'https://automy.global/knowledge_center',
  // Refresh Token Schedule
  TOKEN_EXPIRATION_DEFAULT: 3600,
  REFRESH_TIME_BEFORE_EXPIRATION: 300,
  // [SIMULATION] Forces short token TTL for local testing.
  // Refresh fires in ~1 min after login (6min TTL - 5min REFRESH_BUFFER).
  // Set to null to disable and restore real token expiry behavior.
  TEST_TOKEN_EXPIRES_IN_MS: null,
  QUERY_SEARCH_NUMERIC_KEYS: ['executionOrder'],
  // FIXME: Temporary check current user for process config
  TEMP_DEV_MAILS: [
    'joel.bolivar@aceroyalty.com',
    'frank.villanueva@aceroyalty.com',
    'grabiel.montero@aceroyalty.com',
  ],
  // Mobile ports for location service
  MOBILE_GEOLOCATION_PORTS: [
    9450, 9950, 10051, 16467, 20638, 30485, 35267, 40684, 46714, 48349, 51035, 59746, 61078, 63738,
    64971,
  ],
  // Allowed image formats
  ALLOWED_IMAGE_EXTENSIONS: [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/bmp',
    'image/tiff',
    'image/svg+xml',
    'image/webp',
    'image/heic',
    'image/x-canon-cr2',
    'image/x-nikon-nef',
    'image/x-sony-arw',
    'image/vnd.adobe.photoshop',
    'image/vnd.microsoft.icon',
  ],
  ALLOWED_SHEET_EXTENSIONS: ['.csv', '.ods', '.xla', '.xls', '.xlsx', '.xps'],
  // Date formats
  DATE_PARSE_FORMAT: 'YYYY-MM-DD',
  DATE_TIME_PARSE_FORMAT: 'YYYY-MM-DDTHH:mm:ss',
  // Default page size filter for pagination
  DEFAULT_PAGE_SIZES: [5, 10, 25, 50, 100, 500],
  // REGULAR EXPRESSIONS
  REGEX_SEARCH_CRITERIA: /^[a-zA-Z0-9+-_ ]+$/,
  FORBIDDEN_CHARACTERS: ["'", '"', ';', '--', '#', '%', '\\'],
  FORBIDDEN_SEQUENCES: [
    '--',
    '/* */',
    'xp_',
    'UNION SELECT',
    '<script>',
    'javascript:',
    'CHAR(',
    'EXEC',
    'DROP TABLE',
    'INSERT INTO',
    'OR 1=1',
  ],
  // POLLING INTERVALS RETRIES
  MAX_POLLING_RETRIES: 5,
  DEFAULT_POLLING_INTERVALS: [5, 10, 20, 40, 60, 60, 60, 120, 120, 120],
  // Dashboard Widgets
  STORAGE_WIDGET_ITEMS: [
    { name: 'used-space', countKey: 'spaceUsed', totalKey: 'planTotalSpace', unit: 'GB' },
    { name: 'emails-sent', countKey: 'emailsSent', totalKey: 'planTotalEmails' },
    // {
    //   name: 'entities',
    //   countKey: 'totalEnabledEntities',
    //   totalKey: 'planEntitiesCount',
    //   planKey: 'totalEntities',
    // },
    {
      name: 'generated-documents',
      countKey: 'generatedDocumentsCount',
      totalKey: 'planTotalDocumentsCount',
    },
  ],
  BOARD_WIDGET_ITEMS: [
    {
      name: 'requests',
      countKey: 'totalRequestsCount',
      totalKey: 'planRequestsCount',
      className: 'requests',
      type: 1,
    },
    {
      name: 'enabled-processes',
      countKey: 'totalEnabledProcess',
      totalKey: 'totalProcess',
      className: 'processes',
      type: 2,
    },
    {
      name: 'active-users',
      countKey: 'totalEnabledUsers',
      totalKey: 'totalUsers',
      className: 'users',
      type: 3,
    },
  ],
  // MAX RETRY FOR FAILED CALLS
  MAX_RETRY_ATTEMPTS: 10,
  // AZURE APPLICATION INSIGHTS
  APPLICATIONINSIGHTS_CONNECTION_STRING:
    'InstrumentationKey=789d33a5-2adb-49e7-8a8b-ff33f982263b;IngestionEndpoint=https://southcentralus-3.in.applicationinsights.azure.com/;LiveEndpoint=https://southcentralus.livediagnostics.monitor.azure.com/;ApplicationId=5185f414-b52d-4359-a4c8-4e55e28c61d8',
};
